'use client';

import type { ComponentProps } from 'react';

import Link from 'next/link';
import { usePostHog } from 'posthog-js/react';

import { MARKETING_ROUTES } from '@/common/constants';
import { useTypedDomain } from '@/components/scan-domain-context';

/**
 * Every route to the booking calendar, so demand can be attributed to a brand. /demo is a server
 * redirect and runs no client code, hence firing the event here on the way out.
 */
export function DemoLink({
  children,
  onClick,
  ...props
}: Omit<ComponentProps<typeof Link>, 'href'>) {
  const posthog = usePostHog();
  const domain = useTypedDomain();

  return (
    <Link
      {...props}
      href={MARKETING_ROUTES.demo}
      onClick={event => {
        // domain is empty whenever the visitor hasn't typed one anywhere yet; the click is still
        // worth recording, just without a brand attached. send_instantly because /demo bounces
        // straight off-site and a batched event wouldn't survive the navigation.
        posthog?.capture('demo_clicked', { domain }, { send_instantly: true });
        onClick?.(event);
      }}
    >
      {children}
    </Link>
  );
}
